import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  SURVEY_EMAIL_REPORT_CONFIG: `${apiUrlConfig.apiEndPoint()}/survey_email_report_config`,
  COMMENT_EMAIL_REPORT_CONFIG: `${apiUrlConfig.apiEndPoint()}/comment_email_report_config`,
  EMAIL_REPORT_CONFIG_UPDATE: `${apiUrlConfig.apiEndPoint()}/email_report_configs/:id`,
  SMS_ALERT_CONFIG_FETCH: `${apiUrlConfig.apiEndPoint()}/sms_alert_config`,
  SMS_ALERT_CONFIG_UPDATE: `${apiUrlConfig.apiEndPoint()}/sms_alert_configs/:id`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class EmailReportConfigApi {
  /**
   * get current users survey email report config
   */
  static getPersonalSurveyEmailReportConfig() {
    return AuthenticatedRequestService.get(URLS.SURVEY_EMAIL_REPORT_CONFIG);
  }

  /**
   * get current users comment email report config
   */
  static getPersonalCommentEmailReportConfig() {
    return AuthenticatedRequestService.get(URLS.COMMENT_EMAIL_REPORT_CONFIG);
  }

  /**
   * update email report config
   */
  static updateEmailReportConfig(
    emailReportConfigId,
    emailInterval,
    isActive,
    reportType
  ) {
    const UPDATE_EMAIL_REPORT_CONFIG_URL = insertIdToUrl(
      URLS.EMAIL_REPORT_CONFIG_UPDATE,
      emailReportConfigId
    );
    const data = {
      email_report_config: {
        email_interval: emailInterval,
        is_active: isActive,
        report_type: reportType,
      },
    };

    return AuthenticatedRequestService.patch(
      UPDATE_EMAIL_REPORT_CONFIG_URL,
      data
    );
  }
  /**
   *  fetch sms alert config
   */

  static getPersonalSmsAlertConfig() {
    return AuthenticatedRequestService.get(URLS.SMS_ALERT_CONFIG_FETCH);
  }

  /**
   *  update sms alert config
   */

  static updatePersonalSmsAlertConfig(id, alert_type, is_active) {
    const URL = insertIdToUrl(URLS.SMS_ALERT_CONFIG_UPDATE, id);
    const data = {
      sms_alert_config: {
        alert_type,
        is_active,
      },
    };
    return AuthenticatedRequestService.patch(URL, data);
  }
}

export default EmailReportConfigApi;



// WEBPACK FOOTER //
// ./src/apis/EmailReportConfig.js